import { lazy } from "react";

const routes = [
  {
    path: "/module",
    element: lazy(() => import("../../pages/ModulePersonalization/Module")),
  },
  {
    path: "/module/create",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/Module/create-editModule"),
    ),
  },
  {
    path: "/module/edit/:id",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/Module/create-editModule"),
    ),
  },
];

export default routes;
